// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlApi: 'api/v1/',
  urlMainApi: 'api/v1/main/',
  urlProductDB: 'api/v1/productDB/',
  urlS3: 'https://drinks-develop.fsn1.your-objectstorage.com/',
  urlS3ProductDB: 'https://drinks.fsn1.your-objectstorage.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
